import { match as matchDirectRoute } from "@faire/web-api--source/routes/www/direct/brandAlias/match";
import { match as matchDirectSalesRepRoute } from "@faire/web-api--source/routes/www/direct/brandAlias/rep/salesRepCode/match";
import { ParsedQuery } from "query-string";

export function getFaireDirectBrandAlias(
  pathname: string,
  queryParams: ParsedQuery
): string | undefined {
  const directMatch = matchDirectRoute(pathname);
  const salesRepCodeMatch = matchDirectSalesRepRoute(pathname);
  if (salesRepCodeMatch) {
    return salesRepCodeMatch.params.brandAlias;
  } else if (directMatch) {
    return directMatch.params.brandAlias;
  }
  if (typeof queryParams.fdb === "string") {
    return queryParams.fdb;
  }
  return undefined;
}

export function getFaireDirectSalesRepCode(
  pathname: string
): string | undefined {
  return matchDirectSalesRepRoute(pathname)?.params?.salesRepCode;
}

export function getFaireDirectWidgetToken(
  queryParams: ParsedQuery
): string | undefined {
  if (typeof queryParams.widgetToken === "string") {
    return queryParams.widgetToken;
  }
  return undefined;
}
